import React, { useEffect, useState } from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDate } from './../helper/formatDate';
import '../commonCss/classesCss.css'
import { useTranslate } from './TranslationText';
import axiosBackend from '../axios/axios';
import { getOrdinal } from '../helper/getOrdinal';
import { convertToCamelCase } from '../helper/convertToCamelCase';
import CustomButton from './CustomButton';

export default function ClassesSection({ showID, newUpdate = 0, islive = false, handleHorseimages }) {
    const { translate } = useTranslate();
    const [days, setClasses] = useState([]);
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    const [expandedDay, setExpandedDay] = useState(false);
    const [expandedClass, setExpandedClass] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [currentHorseId, setCurrentHorseId] = useState('');
    const [currentHorseData, setCurrentHorseData] = useState({});
    async function GetShowClassHorseSoringDetailsWithGallery(horseId = "") {
        try {
            const res = await axiosBackend.get(`/api/Show/GetShowClassHorseSoringDetailsWithGallery?ShowClassHorseId=${horseId}`);
            if (res?.data?.responseCode == "200") {
                setCurrentHorseData(res?.data?.result)
            }

        } catch (error) {

        }

    }

    async function GetHorseSoringWithGallery(horseNumber) {
        try {
            const res = await axiosBackend.get(`/api/Show/GetHorseSoringWithGallery?ShowId=${showID}&HorseNo=${horseNumber}`);
            if (res?.data?.responseCode == "200") {
                setCurrentHorseData(res?.data?.result)
            }
        } catch (error) {

        }
    }

    const handleChange =
        (panel, id, horseNumber) => (event, isExpanded) => {
            if (islive) {
                setCurrentHorseId(id);
                GetShowClassHorseSoringDetailsWithGallery(id);
            } else {
                GetHorseSoringWithGallery(horseNumber);
            }
            setExpanded(isExpanded ? panel : false);
        };
    const handleChangeDay =
        (panel) => (event, isExpanded) => {
            setExpandedDay(isExpanded ? panel : false);
            setExpanded(false);
            setExpandedClass(false);
        };
    const handleChangeClass =
        (panel) => (event, isExpanded) => {
            setExpandedClass(isExpanded ? panel : false);
            setExpanded(false);
        };

    async function getClasses() {
        try {
            const res = await axiosBackend.get(`/api/Show/GetShowClasses?id=${showID}`);

            console.log('classes is', res.data);
            setClasses(res?.data?.result ?? []);

        } catch (error) {
            console.error('error in getting Classes')
        }

    }



    useEffect(() => {
        getClasses();
        if (islive) {
            if (currentHorseId !== "") {
                GetShowClassHorseSoringDetailsWithGallery(currentHorseId);
            }
        }
    }, [newUpdate])


    return (
        days.length > 0 &&
        <div className='mb-2'>
            <h2 className='roboto-custom-black' >{translate('web.classes', 'Classes')}</h2>
            {days.length > 0 && days.map((day, index) => (
                <Accordion className='mb-3' expanded={expandedDay === ('panelDay' + index)} onChange={handleChangeDay('panelDay' + index)}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon className='text-white fw-bold' />}
                        aria-controls="panel-content"
                        id="panel-header"
                        focusVisibleClassName='bg-success'
                        className='bg-dark text-white fw-bold'
                    >
                        {new Date(day?.dayDate).toLocaleDateString(`${currentLanguage}-EG-u-nu-latn`, {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                    </AccordionSummary>
                    <AccordionDetails>
                        {day.showClassesList.map((item, index) => (
                            <Accordion expanded={expandedClass === ('panelClass' + index)} onChange={handleChangeClass('panelClass' + index)}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel-content"
                                    id="panel-header"
                                >
                                    {item?.className}
                                </AccordionSummary>
                                <AccordionDetails>
                                    {item?.showClassHorseList?.length > 0 && item.showClassHorseList.map((horse, index) => (

                                        <Accordion key={horse?.id + 'panelHorse' + horse?.horseName} expanded={expanded === ('panelHorse' + index)} onChange={handleChange(('panelHorse' + index), horse?.id, horse?.horseNumber)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel-content"
                                                id="panel-header"

                                            >
                                                <div className='row w-100' >
                                                    <div className='col-sm-3 col-6' dangerouslySetInnerHTML={{ __html: getOrdinal(horse?.rank, currentLanguage) }} />
                                                    <div className='col-sm-3 col-6 ' >{horse?.horseNumber} – {horse?.horseName}</div>
                                                    <div className='col-sm-3 col-6 text-center' >{horse?.totalPoint} {!!horse?.reason && ' - ' + translate('web.' + convertToCamelCase(horse?.reason), horse?.reason)}</div>
                                                    <div className='col-sm-3 col-6 text-end' >{translate('web.results', 'Results')}</div>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className='row w-100 position-relative'>
                                                    {islive ?
                                                        currentHorseData?.classHorseGallery?.length > 0 && <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12 position-absolute' style={{ top: 0, left: 150 }}>
                                                            <div className='btn btn-success ' style={{ cursor: 'pointer' }} title={translate('web.viewHorseImages', 'View Horse Images')} onClick={() => (handleHorseimages(currentHorseData?.classHorseGallery ?? []))}>
                                                                <i className="fa-solid fa-images"></i>
                                                            </div>
                                                        </div> :
                                                        horse?.classHorseScoringModel?.classHorseGallery?.length > 0 && <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12 position-absolute' style={{ top: 0, left: 150 }}>
                                                            <div className='btn btn-success ' style={{ cursor: 'pointer' }} title={translate('web.viewHorseImages', 'View Horse Images')} onClick={() => (handleHorseimages(horse?.classHorseScoringModel ?? []))}>
                                                                <i className="fa-solid fa-images"></i>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                                                        <h6 className='roboto-light'>
                                                            {translate('web.birthdate', 'Birthdate')}
                                                        </h6>
                                                        <span>{horse?.birthDate && formatDate(horse?.birthDate)}</span>
                                                    </div>
                                                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                                                        <h6 className='roboto-light'>
                                                            {translate('web.sire', 'Sire')}
                                                        </h6>
                                                        <span style={{ textTransform: 'uppercase' }}>{horse?.sire}</span>
                                                    </div>
                                                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                                                        <h6 className='roboto-light'>
                                                            {translate('web.breeder', 'Breeder')}
                                                        </h6>
                                                        <span style={{ textTransform: 'uppercase' }}>{horse?.breeder}</span>
                                                    </div>
                                                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                                                        <h6 className='roboto-light'>
                                                            {translate('web.color', 'Color')}
                                                        </h6>
                                                        <span style={{ textTransform: 'uppercase' }}>{horse?.color}</span>
                                                    </div>
                                                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                                                        <h6 className='roboto-light'>
                                                            {translate('web.dam', 'Dam')}
                                                        </h6>
                                                        <span style={{ textTransform: 'uppercase' }}>{horse?.dam}</span>
                                                    </div>
                                                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                                                        <h6 className='roboto-light'>
                                                            {translate('web.owner', 'Owner')}
                                                        </h6>
                                                        <span style={{ textTransform: 'uppercase' }}>{horse?.owner}</span>
                                                    </div>

                                                    <div className='col-12 mt-2 overflow-auto'>
                                                        <table className='w-100 minWidth600 table table-striped table-bordered'>
                                                            <thead>
                                                                <tr className='bgDarkGray text-center'>
                                                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }} ></th>
                                                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }} >{translate('web.type', 'Type')}</th>
                                                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }} >{translate('web.headAndNeck', 'H&N')}</th>
                                                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }} >{translate('web.body', 'Body')}</th>
                                                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }} >{translate('web.legs', 'Legs')}</th>
                                                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }} >{translate('web.move', 'Move')}</th>
                                                                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }} >{translate('web.total', 'Total')}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentHorseData?.scoringTable?.length > 0 ?
                                                                    currentHorseData?.scoringTable?.map((row, index) => (
                                                                        <tr className='text-center'>
                                                                            <td className='bgDarkGray text-white fw-bold' style={{ background: '#757575' }} >{row?.judgeLetter}</td>
                                                                            <td>{row?.type}</td>
                                                                            <td>{row?.headNeck}</td>
                                                                            <td>{row?.body}</td>
                                                                            <td>{row?.leg}</td>
                                                                            <td>{row?.move}</td>
                                                                            {index == 0 && <td className='bgGray' rowSpan={currentHorseData?.scoringTable?.length}>
                                                                                <div className='d-flex justify-content-center flex-column align-items-center'>
                                                                                    <div className='capatalize_text'>{row?.totalPoints}</div>
                                                                                    <div className='capatalize_text' >{translate('web.points', 'Points')} </div>
                                                                                </div>
                                                                            </td>}
                                                                        </tr>
                                                                    ))
                                                                    : <tr className='text-center'>
                                                                        {/* <td colSpan={7} className='text-center text-danger fw-bold' >{translate('web.noResultsFound', 'No Results Found')}</td> */}
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                        <sub className='mt-2'>
                                                            {translate('web.judge', 'Judges')}: {horse?.classHorseScoringModel?.scoringTable?.map((judgeContainer, index) => (`${judgeContainer?.judgeLetter} - ${judgeContainer?.judgeName}${(index + 1 !== horse?.classHorseScoringModel?.scoringTable?.length) && ', '}`))}
                                                        </sub>
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                    <div className='mx-1 mt-3'>
                                        <span className='fw-bold'>
                                            {translate('web.judges', 'judges')}:
                                        </span>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <p>
                                                    {item.showClassHorseList.map((horse, index) => (
                                                        index == 0 &&
                                                        <>
                                                            {horse?.classHorseScoringModel?.scoringTable?.map((judgeContainer, index) => (`${judgeContainer?.judgeLetter} - ${judgeContainer?.judgeName}${(index + 1 !== horse?.classHorseScoringModel?.scoringTable?.length) && ', '}`))}
                                                        </>
                                                    ))}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    )
}
